import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';
import { takeWhile } from 'rxjs/operators';
import { GlobalService } from '../../services/global.service';
import { Subscription } from 'rxjs';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'hadsup-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  standalone: false,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
})
export class NotificationComponent implements OnInit, OnDestroy {
  @Input() type = 'success';
  @Input() imgSrc = '';
  @Input() message = '';
  @Input() subMessage = '';
  @Input() mainBtnContent = '';
  @Input() secondBtnContent = '';
  selectedAdSlot: any;
  adSpotPrice: number = 0;
  currentBalance: any;
  balanceLoading: boolean=false;
  daysOnDisplay:any;
  slotValue: any;
  @Output() closeLayer: EventEmitter<void> = new EventEmitter<void>();
  public hide: any;
  public alive = true;
  private routerSubscription!: Subscription;
  constructor(private globalService: GlobalService, private router: Router,private storageService:StorageService) {
    this.hide = this.globalService.hideNotification$;
    const allBalances:any = this.storageService.getProfileInfo()?.relations?.balance;
    if (allBalances) {
      this.currentBalance = allBalances.balance;
      this.balanceLoading = true;
    } else {
      this.balanceLoading = false;
    }
  }
  ngOnInit(): void {
    if (this.message === 'select-ad-spots') {
      this.globalService.selectedAdNum$
        .pipe(takeWhile(() => this.alive))
        .subscribe((res) => {
          setTimeout(() => {
          this.selectedAdSlot= res;
          const selectedDevices = this.storageService.getSelectedDevices().filter((e)=>e.selected);
          selectedDevices.forEach(device => {
                      const slotCount = device.slots?.length;
                      device['total_base_cost'] = slotCount * device.base_cost;
                        const slots = device.slots;
                                if (slots && slots.length > 0) {
                                const startDate = new Date(slots[0].date);
                                const endDate = new Date(slots[slots.length - 1].date);
                                const diff = endDate.getTime() - startDate.getTime();
                                const days = Math.floor(diff / (1000 * 60 * 60 * 24)) + 1;
                                this.daysOnDisplay = days;
                            }
                  });
          // const price = selectedDevices.reduce((a: any, b: any) => a + b.total_base_cost,0);
          this.adSpotPrice = selectedDevices.reduce((sum, device) => sum + (device['total_base_cost'] || 0), 0);
          this.slotValue = selectedDevices.reduce((sum, device) => sum +  (device.slots?.length || 0), 0);
          }, 600);
          if (!res) {
              this.close();
          }
      });
    }
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.close(); 
      }
    });
  }

  ngOnDestroy(): void {
    this.alive = false;
     if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  close() {
    this.closeLayer.emit();
  }

  mainBtnAction() {
    if (this.mainBtnContent === 'Preview & costs') {
      this.router.navigate(['/preview-costs']);
    }
    else {
      if (this.router.url.indexOf('single-ad-spot') > -1)
        this.router.navigate(['/advertiser/create-campaign']);
      this.globalService.setProceedNotificationClick(true);
    }
  }
}
